module.exports = __webpack_public_path__ + "static/media/solar-panel-color.585997a6.svg";